// Lib
import React from 'react';
import { NodeViewProps } from '@tiptap/core';

// Components
import useSyncInlineBoardLinkDetails from './useSyncInlineBoardLinkDetails';
import Spinner from '../../../../client/components/loaders/Spinner';

// Constants
import { InlineBoardLinkOptions } from './inlineBoardLinkConstants';

/**
 * Renders a loading state for the inline board link, while fetching the details.
 */
const InlineBoardLinkInitialContent: React.FC<NodeViewProps> = (props) => {
    const { node, extension, editor, getPos } = props;
    const { title } = node.attrs;
    const { dispatchFetchInlineBoardLinkDetails } = extension.options as InlineBoardLinkOptions;

    const renderedText = title || 'Fetching...';

    useSyncInlineBoardLinkDetails({
        dispatchFetchInlineBoardLinkDetails,
        attrs: node.attrs,
        editor,
        getPos,
    });

    return (
        <span className="pill">
            <Spinner show />
            <span className="board-title">{renderedText}</span>
        </span>
    );
};

export default InlineBoardLinkInitialContent;
